import React from 'react';
import PropTypes from 'prop-types';

import LabsUniClosedLogo from '../../../../../../assets/images/labs-uni-closed-logo.svg';
import StakingStub from '../../../../../../components/staking-stub';
import { LABS_UNI } from '../../../../../../constants/blockchain-constants';

const ClosedStub = ({ text }) => (
  <>
    <StakingStub type={LABS_UNI} icon={LabsUniClosedLogo} text={text} />
  </>
);

ClosedStub.propTypes = {
  text: PropTypes.string,
};

ClosedStub.defaultProps = {
  text: 'The LABS staking pool is closed for more staking.',
};

export default ClosedStub;
